import * as exportInvoice from '../services/export_invoice';

export default {
  namespace: 'exportInvoice',
  state: {
    trackingData: {},
  },
  effects: {
    *invoiceExport({ payload: { values }, callback }, { call, put }) {
      const response = yield call(exportInvoice.invoiceExport, values);
      yield put({
        type: 'save',
        payload: {},
      });
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
    },
  },
  reducers: {
    save(state, action) {
      return { ...state, ...action.payload };
    },
  },
};
